/**
 * 处理菜单栏树结构
 */
export const flat2treeHelp = (arr, parentIdKey = 'parentMenuId') => {
  // 没有parentId的顶层
  let res = arr.filter((item) => !item[parentIdKey])
  const helpObj = arr.reduce((o, v) => ((o[v.id] = v), o), {})
  // push进父级
  arr.forEach((item) => {
    if (item[parentIdKey]) {
      const matchHelpObj = helpObj[item[parentIdKey]]
      matchHelpObj.children = (matchHelpObj.children ? matchHelpObj.children : []).concat([item])
    }
  })
  return res
}

/**
 * 转成扁平数据
 */
export const tree2flatHelp = (data) => {
  const fn = (arr, acc = {}) => {
    return arr.reduce((last, item) => {
      last[item.id] = { ...item } // 创建新对象副本并添加到累积对象中
      if (item.children && item.children.length > 0) {
        // 递归处理子节点并将结果合并到累积对象中
        Object.assign(last, fn(item.children, {}))
      }
      return last
    }, acc)
  }
  const result = fn(data)
  return result
}
